/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Breadcrumb/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Documents from './Documents/index'
import ImageSeries from './ImageSeries/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Breadcrumb({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Tools/AttachmentAction/InApp/Documents/Content/Patients/Content/Breadcrumb"
  
}) {
  let flow = fromFlow.useFlow()
  return (<React.Fragment
>
<div
  data-testid="Breadcrumb.Vertical"
  data-view-path={viewPath}
 style={{'--d-1-Z1phN6b': flow.has("/App/Account/Content/Comms/ActiveThread/Content/MessageTools/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/Documents") ? "visible" : "none"}}
 className={`views-block ${styles.Vertical}`}
>
<Documents
  viewPath={`${viewPath}/Documents`}
/>
</div>
<div
  data-testid="Breadcrumb.Vertical:1"
  data-view-path={viewPath}
 style={{'--d-1-Z1phN6b': flow.has("/App/Account/Content/Comms/ActiveThread/Content/MessageTools/Tools/AttachmentAction/InApp/Documents/Content/SystemFiles/FilesTree/ImageSeries") ? "visible" : "none"}}
 className={`views-block ${styles.Vertical1}`}
>
<ImageSeries
  viewPath={`${viewPath}/ImageSeries`}
/>
</div>
{children}
</React.Fragment>)
}